import * as React from "react";
import { ComponentClass } from "react";
import * as classNames from "classnames";
import { IStore } from "../store";
import withStyles, { ClassNameMap } from "@material-ui/core/styles/withStyles";
import { MenuItem, Theme, Tooltip } from "@material-ui/core";
import { connect } from "react-redux";
import { AuthActions } from "../store/auth/auth-actions";
import { bindActions, mockTheme } from "../utils/utils";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import LockOutline from "@material-ui/icons/LockOutline";

// pages
import Races from "./races";
import Dashboard from "./DashboardPage";
import Client from "./client";
import DriverListPage from "./DriverListPage";
import Admin from "./admin";
import Messages from "./MessagesPage";

import { IUser } from "../utils/userHandler";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import MenuList from "../components/MenuList";
import { Switch, Route } from "react-router";
import { BrowserRouter, Link } from "react-router-dom";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { ConfigData } from "../config";

// pages
import PrivacyPolicyPage from "./PrivacyPolicyPage";
import RacePage from "./RacePage";
import CompanyPage from "./CompanyPage";
import DriverPage from "./DriverPage";
import ReportsPage from "./ReportsPage";
import CategoryListPage from "./CategoryListPage";
import ProductListPage from "./ProductListPage";
import DeliveryPage from "./DeliveryPage";
import login from "./login";
import Branch from "./branch";

const drawerWidth = 240;

const styles = (theme: Theme) => ({
  root: {
    flexGrow: 1,
    height: "100%",
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),

    "& a": {
      textDecoration: "none",
    },
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 12,
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing.unit * 8,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 1,
  },
});

const classesType = styles(mockTheme);

interface LayoutProps {
  user: IUser;
  actions: AuthActions;
  classes: ClassNameMap<keyof typeof classesType>;
  config: ConfigData;
  isLogged: boolean;
}

interface LayoutState {
  open: boolean;
  selectedIndex: number;
}

const Page404: React.SFC<{}> = () => (
  <div>
    <h3>
      La página que accediste no existe!.
      <Link to="/">volver al Inicio</Link>
    </h3>
  </div>
);

const routes = [
  { path: "/", component: Dashboard },
  { path: "/client", component: Client },
  { path: "/admin", component: Admin },
  { path: "/message", component: Messages },
  { path: "/company", component: CompanyPage },
  { path: "/races", component: Races },
  { path: "/race/:id", component: RacePage },
  { path: "/driver/:id", component: DriverPage },
  { path: "/driver", component: DriverListPage },
  { path: "/reports", component: ReportsPage },
  { path: "/category", component: CategoryListPage },
  { path: "/product", component: ProductListPage },
  { path: "/delivery", component: DeliveryPage },
  { path: "/branch", component: Branch },
  { path: "/privacy-policy", component: PrivacyPolicyPage },
  { path: "*", component: Page404 },
];

class Layout extends React.Component<LayoutProps, LayoutState> {
  constructor(props: any) {
    super(props);

    this.state = {
      open: false,
      selectedIndex: 0,
    };

    this.handleLogout = this.handleLogout.bind(this);
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.handleListItemClick = this.handleListItemClick.bind(this);
  }

  handleLogout() {
    this.props.actions.logout();
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleListItemClick = (index: number) => {
    this.setState({ selectedIndex: index });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  render() {
    const classes = this.props.classes;
    const config = this.props.config;
    const isLogged = this.props.isLogged;

    return (
      <BrowserRouter>
        <div className={classes.root}>
          <AppBar
            position="absolute"
            className={classNames(
              classes.appBar,
              this.state.open && classes.appBarShift
            )}
          >
            <Toolbar disableGutters={!this.state.open}>
              {isLogged && (
                <>
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={this.handleDrawerOpen}
                    className={classNames(
                      classes.menuButton,
                      this.state.open && classes.hide
                    )}
                  >
                    <MenuIcon />
                  </IconButton>

                  <Typography variant="title" color="inherit" noWrap>
                    {config.name}
                  </Typography>
                </>
              )}
            </Toolbar>
          </AppBar>

          {isLogged && (
            <Drawer
              variant="permanent"
              classes={{
                paper: classNames(
                  classes.drawerPaper,
                  !this.state.open && classes.drawerPaperClose
                ),
              }}
              open={this.state.open}
            >
              <div className={classes.toolbar}>
                <IconButton onClick={this.handleDrawerClose}>
                  <ChevronLeftIcon />
                </IconButton>
              </div>
              <Divider />
              <List>
                <MenuList
                  clickMenu={this.handleListItemClick}
                  selectedIndex={this.state.selectedIndex}
                />{" "}
              </List>
              <Divider />
              <List>
                <Tooltip title="Salir" placement="bottom">
                  <MenuItem button onClick={this.handleLogout}>
                    <ListItemIcon>
                      <LockOutline />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                  </MenuItem>
                </Tooltip>
              </List>
            </Drawer>
          )}
          <main className={classes.content}>
            <div className={classes.toolbar} />
            <Switch>
              {routes.map((route, key) => {
                const { path, component } = route;
                if (isLogged) {
                  return (
                    <Route key={key} exact path={path} component={component} />
                  );
                } else {
                  return console.log("no logged");
                }
              })}

              <Route
                exact
                path="/privacy-policy"
                component={PrivacyPolicyPage}
              />
              <Route component={login} />
            </Switch>
          </main>
        </div>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state: IStore, ownProps: LayoutProps) => ({
  user: state.auth.user,
  config: state.config.data,
  ...ownProps,
});

const styled = withStyles(styles as any)<LayoutProps>(Layout);
const connected = connect(mapStateToProps, bindActions(AuthActions))(styled);

export default connected as ComponentClass<Partial<LayoutProps>>;



// WEBPACK FOOTER //
// ./src/pages/layout.tsx